//@ts-nocheck
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import ErrorBoundary from "./ErrorBoundary";
import MainRouter from "./MainRouter";
import CanvasApp from "./components/Polotno/StandaloneCanvas";
import { Provider } from "react-redux";
import mainStore from "./MainStore/store";
import Widget from "./components/Widget/Widget";

const THEME = createTheme({
  typography: {
    fontFamily: `"Quicksand", sans-serif`,
    fontSize: 13,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    widgetVariant: {
      fontFamily: `"Poppins", sans-serif`,
    },
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          padding: "0px 4px 0px 6px",
        },
        input: {
          padding: "0px 4px 0px 6px",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "#4c4d52",
          fontWeight: 500,
          fontSize: "14px",
        },
        asterisk: {
          color: "#E41F00",
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        active: {
          background: "linear-gradient(270.01deg, #D42C5A 33.09%, #286CD6 55.2%)",
          height: "2.5px",
        },
        root: {
          background: "linear-gradient(270.01deg, #D42C5A 33.09%, #286CD6 55.2%)",
          height: "2.5px",
        },
      },
    },
    MuiDivider: {
      variants: [
        {
          props: { variant: "gradient" },
          style: {
            background: "linear-gradient(270.01deg, #D42C5A 33.09%, #286CD6 55.2%)",
            height: "2px",
          },
        },
      ],
    },
  },
  palette: {
    text: {
      primary: "#4c4d52",
    },
    primary: {
      main: "#296bd6",
    },
    secondary: {
      main: "#4c4d52",
    },
    background: {
      primary: "#E5EDFB",
      light: "#fafafa",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <>
    {/* <SideNavBar />
      <ContentAnalysis /> */}
    {/* <ThemeProvider theme={THEME}></ThemeProvider> */}
    <ThemeProvider theme={THEME}>
      <CssBaseline />
      <ErrorBoundary>
        <BrowserRouter>
          <Provider store={mainStore}>
            {/* <MainRouter /> */}
            <Widget/>
          </Provider>
          {/* <CanvasApp/> */}
        </BrowserRouter>
      </ErrorBoundary>
    </ThemeProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
